import PropTypes from 'prop-types';

import {OEVHLayoutType} from '../../../lib/components/oe-vh-layouter';
import {OEPresentationPlayableFlags} from '../presentation/oe-presentation-model';

export const OEMediaCenterItemTypes = {
    none:                                   -1,
    dummy:                                  0,
    animation:                              1,
    accessory:                              2,
    image:                                  3,
    video:                                  4,
    timeline:                               5,
    html:                                   6,
    pdf:                                    7,
    presentation:                           8,
    separator:                              9
};

OEMediaCenterItemTypes.all = Object.values(OEMediaCenterItemTypes);

//
export const OEMediaCenterItemLayoutType = {
    std:                                    0,
    nameTop:                                1
};

//
export const OEMediaCenterIconType = {
    icon:                                   0,
    text:                                   1,
    std:                                    0
};

//
export const OEMediaCenterCategoryFlags = {
    none:                                   0,
    hideInMediaCenter:                      1
};

//
export const OEMediaCenterItemFlags = {
    none:                                   0,
    allowVPGizmo:                           1,
    noThumbImage:                           2
};

//
export const OEMediaCenterMode = {
    std:                                    0,
    bottomBar:                              1
};

//
export const OEMediaCenterAutoplayMode = {
    none:                                   0,
    std:                                    1,
    directPlay:                             2,
    directPlayTrap:                         3
};

OEMediaCenterAutoplayMode.all = Object.values(OEMediaCenterAutoplayMode);

OEMediaCenterAutoplayMode.isPlay = function(mode)   {
    return [OEMediaCenterAutoplayMode.std, OEMediaCenterAutoplayMode.directPlay, OEMediaCenterAutoplayMode.directPlayTrap].includes(mode);
};

OEMediaCenterAutoplayMode.isDirectPlay = function(mode)   {
    return [OEMediaCenterAutoplayMode.directPlay, OEMediaCenterAutoplayMode.directPlayTrap].includes(mode);
};

//
export const OEMediaCenterModeBottomBarLayoutType = OEVHLayoutType;

//
export const OEMediaCenterPropTypes = {

    commonConfig: {
        mode:                               PropTypes.oneOf(Object.values(OEMediaCenterMode)),
        hideBottomBarControlsForItems:      PropTypes.arrayOf(PropTypes.oneOf(OEMediaCenterItemTypes.all)),
        hideSliderForItems:                 PropTypes.arrayOf(PropTypes.oneOf(OEMediaCenterItemTypes.all)),
        bigPlayBtn:                         PropTypes.bool,
        presPlayableFlags:                  PropTypes.number,
        presPreviewOnlyInPlayMode:          PropTypes.bool,
        presMagnification:                  PropTypes.number
    }
};

OEMediaCenterPropTypes.bottomBarConfig = Object.assign(
    {
        noPresPreview:                         PropTypes.number,
    },
    OEMediaCenterPropTypes.commonConfig
);

OEMediaCenterPropTypes.bottomBarConfigDecl = PropTypes.shape(OEMediaCenterPropTypes.bottomBarConfig);

OEMediaCenterPropTypes.config = Object.assign(
    {
        showHelpBtn:                            PropTypes.bool,
        hideCategoryBarIfNotNeeded:             PropTypes.bool,
        hideLeftSlideInInPlayMode:              PropTypes.bool,
        autoplay:                               PropTypes.oneOf(OEMediaCenterAutoplayMode.all),
        playModeControlsFadeOut:                PropTypes.bool
    },
    OEMediaCenterPropTypes.commonConfig
);

OEMediaCenterPropTypes.configDecl = PropTypes.shape(OEMediaCenterPropTypes.config);

OEMediaCenterPropTypes.defaultBottomBarConfig = {
    mode:                                   OEMediaCenterMode.std,
    hideBottomBarControlsForItems:          [],
    hideSliderForItems:                     [],
    bigPlayBtn:                             false,
    presPlayableFlags:                      OEPresentationPlayableFlags.all,
    presPreviewOnlyInPlayMode:              false,
    noPresPreview:                          false,
    presMagnification:                      1.65,
};

//
export const OEMediaCenterConfigFactory = {

    std: function(bigPlayBtnStyle, autoplay = OEMediaCenterAutoplayMode.none)   {
        let res = {
            showHelpBtn:                    true,
            mode:                           OEMediaCenterMode.std,
            hideBottomBarControlsForItems:  [],
            hideSliderForItems:             [],
            bigPlayBtn:                     false,
            hideCategoryBarIfNotNeeded:     false,
            presPlayableFlags:              OEPresentationPlayableFlags.all,
            presPreviewOnlyInPlayMode:      false,
            hideLeftSlideInInPlayMode:      false,
            autoplay:                       autoplay,
            presMagnification:              1.65,
            playModeControlsFadeOut:        true
        };
    
        if(bigPlayBtnStyle) {
            res.hideBottomBarControlsForItems = [OEMediaCenterItemTypes.presentation, OEMediaCenterItemTypes.animation];
            res.hideSliderForItems          = [];
            res.bigPlayBtn                  = true;
            res.hideCategoryBarIfNotNeeded  = true;
            res.presPlayableFlags           = OEPresentationPlayableFlags.audioAnimatableAttribute;
            res.presPreviewOnlyInPlayMode   = true;
        }
    
        return res;
    }
};